import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

// Pita kecil di atas layar saat perangkat kehilangan koneksi internet.
export default function NetworkStatus() {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (online) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[70] pt-safe bg-terracotta text-white" role="status" data-testid="offline-banner">
      <div className="flex items-center justify-center gap-2 text-xs font-medium py-1.5">
        <WifiOff size={14} /> Anda sedang offline — data mungkin belum terbaru
      </div>
    </div>
  );
}
